import { SplitsLink as Link } from '~/components/Link'
import { SplitsDialogContent } from '~/components/component-library/Dialog'
import { useAutoEarnToggle } from '~/components/forms/earn/useAutoEarnToggle'
import { EARN_GUIDE_URL } from '~/constants/externalUrls'
import { useAutoEarnApy } from '~/hooks/useAutoEarnApy'
import { OrgSmartAccount } from '~/types'
import { getApyPhrase } from '~/utils/vault'

export const EnableAutoEarnDialogContent = ({
  smartAccount,
  closeDialog,
}: {
  smartAccount: OrgSmartAccount
  closeDialog: () => void
}) => {
  // Only handleToggle is used, so skip the pending-transactions query
  const { handleToggle } = useAutoEarnToggle(smartAccount, { enabled: false })
  const { apy, providerName } = useAutoEarnApy()

  return (
    <SplitsDialogContent
      id="enableAutoEarn"
      variant="cta"
      title="Enable earn automation"
      actionButton={{
        text: 'Enable',
        onClick: () => {
          closeDialog()
          void handleToggle(true)
        },
      }}
      cancelButton={{ onClick: closeDialog }}
    >
      <p>
        Automatically earn {getApyPhrase(apy)} on any Base USDC in your account.
        Powered by {providerName}.{' '}
        <Link path={EARN_GUIDE_URL} target="tab" underline>
          Learn more
        </Link>
      </p>
    </SplitsDialogContent>
  )
}
